import { useTranslation } from "react-i18next";
import { localizePath } from "./languages";

// Returns a function that adds the current language prefix to an app path.
export default function useLocalizedPath() {
  const { i18n } = useTranslation();
  return (path) => localizePath(path, i18n.resolvedLanguage);
}
